import cn from 'clsx'
import s from './Hero.module.scss'
import { FC, useRef } from 'react'
import { Text, CustomImage, Container, Button } from '@components/ui'
import { isMobileWidth } from '@utils/helpers'
import { useWindowSize } from '@hooks/useWindowSize'
import Image from 'next/image'
import { LoreThreeDetailPage } from '@generated/model/loreThreeDetailPage'
import Link from 'next/link'
import { OffRoad, Road } from '@components/icons'

type HeroProps = {
  page: LoreThreeDetailPage
}

const Hero: FC<HeroProps> = ({ page }) => {
  const windowSize = useWindowSize()
  const isMobile = isMobileWidth(windowSize.width)

  if (!page.hero) return null

  return (
    <>
      <section className={s.root}>
        <div className={s.inner}>
          <div className={s.backgroundContainer}>
            <svg
              width="100"
              height="100"
              className={s.gradient}
              aria-hidden="true"
              focusable="false"
            >
              <defs>
                <linearGradient
                  id="greenToWhite"
                  x1="0%"
                  y1="0%"
                  x2="0%"
                  y2="100%"
                >
                  <stop
                    offset="0%"
                    stopColor="var(--page-color)"
                    stopOpacity="0.2"
                  />
                  <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0.2" />
                </linearGradient>
              </defs>
              <rect
                x="0"
                y="0"
                width="100%"
                height="100%"
                fill="url(#greenToWhite)"
              />
            </svg>
          </div>

          <div className={s.image}>
            <CustomImage data={page.hero} />
            {/* {page.color_scheme &&
            (page.color_scheme as unknown as string) == 'green' ? (
              <OffRoad className={s.overlayIcon} />
            ) : (
              <Road className={s.overlayIcon} />
            )} */}
          </div>
        </div>
        <Container>
          <div className={s.grid}>
            <div className={s.iconContainer}>
              <div className={s.icon}>
                <Image
                  src={page.hero.icon as string}
                  width={50}
                  height={50}
                  layout="fill"
                />
              </div>
              <Text className={s.byline} variant="smallText">
                {page.heading}
              </Text>
            </div>
            <div className={s.col}>
              <div className={s.titleContainer}>
                <Text
                  html={page.variant_title}
                  className={s.title}
                  variant="headingLarge"
                />
              </div>
            </div>
            <div className={s.col}>
              <Text html={page.hero.detail} className={cn(s.detail)} />

              <div className={s.buttonContainer}>
                <Link href={page.hero.order_link || ''}>
                  <a className={s.button}>Order Now</a>
                </Link>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  )
}

export default Hero
